<template>
  <div>
    <v-toolbar
      v-if="stripePaymentMethods && stripePaymentMethods.length > 0"
      :class="toolbarMargin"
      flat
      color="transparent"
    >
      <v-toolbar-title>{{ $t('message.your_cards') }}</v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" @click="createDialog = true"
        ><v-icon left>mdi-plus</v-icon> {{ $t('message.add_card') }}
      </v-btn>
    </v-toolbar>
    <v-row v-if="loadingLegalEntity" no-gutters justify="center" class="py-12">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </v-row>

    <v-radio-group
      v-else-if="legalEntity"
      v-model="selectedMethod"
      hide-details
      class="mt-0 pa-0"
      mandatory
      @change="$emit('change', $event)"
    >
      <div v-if="stripePaymentMethods && stripePaymentMethods.length > 0">
        <v-list color="pa-0" two-line>
          <template v-for="(paymentMethod, index) in stripePaymentMethods">
            <v-divider v-if="index > 0" :key="index" :inset="true"></v-divider>
            <v-list-item
              :key="paymentMethod.id"
              :class="{ 'blue lighten-5': selectedMethod === paymentMethod }"
              @click="selectMethod(paymentMethod)"
            >
              <v-list-item-avatar>
                <v-img
                  :src="
                    require('@/assets/img/payment_methods/' +
                      paymentMethod.card.brand.toLowerCase().replace(/ /g, '-') +
                      '.svg')
                  "
                  alt="Credit Card Icons"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ getCardLabel(paymentMethod.card) }}
                  <span v-if="paymentMethod.billing_details.name" class="grey--text text--darken-2"
                    >({{ paymentMethod.billing_details.name }})</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t('message.expires_in') }}

                  {{ $moment.months(paymentMethod.card.exp_month - 1) }}
                  <template v-if="'es' === $i18n.locale">de</template>
                  {{ paymentMethod.card.exp_year }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-radio :key="paymentMethod.id" :value="paymentMethod"></v-radio>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div v-else class="py-12 text-center">
        <div class="mb-3">
          <v-icon size="64" color="grey">mdi-credit-card-off-outline</v-icon>
        </div>
        <div class="headline grey--text mb-6">
          {{ $t('message.no_payment_methods_provided') }}
        </div>
        <div>
          <v-btn depressed color="primary" @click="createDialog = true"
            ><v-icon left>mdi-plus</v-icon> {{ $t('message.add_card') }}
          </v-btn>
        </div>
      </div>
    </v-radio-group>

    <v-dialog v-model="createDialog" max-width="400" persistent>
      <PaymentMethodCreate
        v-if="legalEntity"
        :legal-entity="legalEntity"
        @created="cardCreated"
        @close="createDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import PaymentMethodCreate from '@/views/payment_method/Create'
import fetch from '@/utils/fetch'

export default {
  name: 'PaymentMethodSelector',
  components: { PaymentMethodCreate },
  props: {
    agreement: {
      type: Object,
      required: false,
      default: null
    },
    legalEntityId: {
      type: String,
      required: false,
      default: null
    },
    toolbarMargin: {
      type: String,
      required: false,
      default: null
    },
    excludePaymentMethod: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedMethod: this.agreement ? this.agreement.stripeSource : null,
      createDialog: false,
      legalEntity: null,
      loadingLegalEntity: false
    }
  },
  computed: {
    stripePaymentMethods() {
      if (!this.legalEntity) {
        return
      }
      const _this = this
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      let methods = this.legalEntity.stripePaymentMethods.filter(method => {
        return method.id !== this.excludePaymentMethod
      })

      return methods.sort(a => {
        if (!_this.agreement || !_this.agreement.stripeSource) {
          return 0
        }
        return _this.agreement.stripeSource.id === a.id ? -1 : 0
      })
    }
  },

  mounted() {
    this.getLegalEntity()
  },

  methods: {
    selectMethod(paymentMethod) {
      this.selectedMethod = paymentMethod
      this.$emit('change', paymentMethod)
    },
    getCardLabel(card) {
      return this.$t('message.payment_methods.brand.' + card.brand) + ' •••• ' + card.last4
    },

    cardCreated() {
      this.createDialog = false
      this.getLegalEntity()
      this.$emit('cardCreated')
    },

    getLegalEntity() {
      this.loadingLegalEntity = true
      fetch((this.legalEntityId || this.agreement.legalEntity['@id']) + '?stripe=true')
        .then(response => response.json())
        .then(data => {
          this.legalEntity = data
          this.loadingLegalEntity = false
        })
        .catch(() => {
          this.loadingLegalEntity = false
        })
    }
  }
}
</script>
